import React from 'react'
import "./AboutSection.css"

export default function AboutSection() {
  return (
    <div>
        <div className="v1_about_us_section" id="about">
  <div className="container">
    <div className="row flex-row-reverse align-items-center">
      <div className="col-md-6">
        <div className="v1_about_us_right_sect">
          <div className="bithu_title_section">
            <h2>
       
            </h2>
            <h3>About Us</h3>
          </div>
          <div className="v1_about_us_right_text">
            <p className="bak">
            Introducing the BitrockWallet NFT Genesis Edition!
            </p>
            <p className="bak">
            As the first NFT collection from BitrockWallet, the native crypto wallet of BitrockChain Ecosystem, this exclusive series brings a new era of NFT culture. Each piece is a unique, rare, and scarce digital art collectible, imbued with meaning and value.
            </p>
            <p className="bak">
            Mint. Collect. Earn Rewards. Trade.
            </p>
            <p className="bak">
            Join our community and unlock real earning potential:
            </p>
            <p className="bak">
            -Stake your NFTs to earn $BRW rewards with attractive APY.
            </p>
            <p className="bak">
            -Hold your NFTs to qualify for our weekly $BROCK Raffle competition and earn $BROCK rewards.
            </p>
            <p className="bak">
            -Trade your NFT art card on secondary market.
            </p>
            <p className="bak">
            Don't miss out on this groundbreaking opportunity. Be a part of the BitrockWallet NFT Genesis Edition and experience the future of digital art and collectibles
            </p>
          </div>
        </div>
      </div>
      <div className="col-md-6 d-none">
      
        <video className='w-100' src="assets/images/nft genesis edition.gif.mp4" autoPlay muted loop></video>
      </div>
    </div>
    
  </div>
</div>

    </div>
  )
}
